import createPersistedState from "./createPersistedState";
import useTenant from "./useTenant";

const useEnvState = createPersistedState<string>("environment_name");

const useEnv = () => {
  const { tenant } = useTenant();
  const environments = tenant?.environments;
  const [selectedEnvName, setSelectedEnvName] = useEnvState("");
  if (!environments || !environments.length) {
    return {
      selectedEnv: null,
      setSelectedEnvName,
    };
  }
  let selectedEnv = environments.filter((environment) => {
    return environment.name === selectedEnvName;
  })[0];

  if (!selectedEnv) selectedEnv = environments[0];

  return {
    selectedEnv,
    setSelectedEnvName,
  };
};

export const useToken = () => {
  const { selectedEnv } = useEnv();
  return selectedEnv?.token;
};

export default useEnv;
